export enum ApiTypeEnum {
	User = "user",
	Transaction = "transaction",
	Other = "other",
	Location = "location",
	noMetaType = "noMetaType",
}
